module.exports = __webpack_public_path__ + "static/UBCLaunchPad-545ea3ac5dce16cceebd35845d74e787.svg";